import { Editor } from '@tiptap/react'
import React from 'react'
import { useGroupedToolbarCommands } from '../hooks/use-grouped-toolbar-command'
import { ToolbarButtonUi } from '../ui/toolbar-button-ui'

interface InlineStyleControlsProps {
  editor: Editor
}

export const InlineStyleControls = ({ editor }: InlineStyleControlsProps) => {
  const { inlineStylesControls } = useGroupedToolbarCommands(editor)
  return (
    <>
      {inlineStylesControls.map(({ icon: Icon, command, type }) => (
        <ToolbarButtonUi
          key={type}
          onClick={command}
          active={editor.isActive(type)}
        >
          <Icon />
        </ToolbarButtonUi>
      ))}
    </>
  )
}
